/* eslint-disable prefer-const */
import axios from 'axios';

import Cookies from '../utils/cookies';

import { Message } from 'element-ui';
import { coreEndpoint, coreLogserverEndpoint, coreFileserverEndpoint, coreWeddingDressHallEndpoint } from '@/settings';

let cancel;
let promiseArr = {};
const CancelToken = axios.CancelToken;

axios.defaults.baseURL = coreEndpoint;
axios.defaults.timeout = 50000;
axios.defaults.withCredentials = true;

// request interceptor
axios.interceptors.request.use(
  config => {
    config.headers['content-type'] = 'application/json';
    config.headers.token = Cookies.getToken();
    config.headers.type = 'web';

    // 处理服务器地址


    if (config.url.indexOf('/logserver/') !== -1) {
      config.url = config.url.replace('/logserver', '');
      config.url = coreLogserverEndpoint + config.url;
    }

    if (config.url.indexOf('/fileserver/') !== -1) {
      config.url = config.url.replace('/fileserver', '');
      config.url = coreFileserverEndpoint + config.url;
    }

    if (config.url.indexOf('/weddingDressHall/') !== -1) {
      config.url = config.url.replace('/weddingDressHall', '');
      config.url = coreWeddingDressHallEndpoint + config.url;
    }

    // 发起请求时，取消掉当前正在进行的相同请求
    if (config.method !== 'get') {
      if (promiseArr[config.url]) {
        promiseArr[config.url]('操作取消');
        promiseArr[config.url] = cancel;
      } else {
        promiseArr[config.url] = cancel;
      }
    }

    if (localStorage.getItem('Ip') != null) {
      config.headers['web-ip'] = localStorage.getItem('Ip');
    }
    return config;
  },
  error => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
axios.interceptors.response.use(
  response => {
    // console.log('testreponse', response)
    const resCode = response.status || response.data.code;
    // if the custom code is not 20000, it is judged as an error.
    if (resCode !== 200) {
      Message({
        message: response.data.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      });
      return Promise.reject(new Error(response.data.message || 'Error'));
    } else {
      return response;
    }
  },
  err => {
    // 请求的错误判断,根据不同的错误码不同消息提醒
    console.log('testErr', err.message);
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          err.message = '错误请求';
          Message.error(err.message); // 错误提示,记得引入message
          break;
        case 401:
          err.message = '授权已失效，请重新登录';
          // err.message = '未授权，请重新登录'
          Message.error(err.message); // 错误提示,记得引入message
          break;
        case 403:
          err.message = '拒绝访问，请重新登录';
          Message.error(err.message); // 错误提示,记得引入message
          break;
        case 404:
          err.message = '请求错误,未找到该资源';
          Message.error(err.message); // 错误提示,记得引入message
          break;
        case 405:
          err.message = '请求方法未允许';
          Message.error(err.message); // 错误提示,记得引入message
          break;
        case 408:
          err.message = '请求超时';
          Message.error(err.message); // 错误提示,记得引入message
          break;
        case 500:
          err.message = '服务器端出错';
          break;
        case 501:
          err.message = '网络未实现';
          break;
        case 502:
          err.message = '网络错误';
          Message.error(err.message); // 错误提示,记得引入message
          break;
        case 503:
          err.message = '服务不可用';
          break;
        case 504:
          err.message = '网络超时';
          Message.error(err.message); // 错误提示,记得引入message
          break;
        case 505:
          err.message = 'http版本不支持该请求';
          Message.error(err.message); // 错误提示,记得引入message
          break;
        default:
          err.message = `连接错误${err.response.status}`;
      }
    } else {
      err.message = '连接到服务器失败';
    }
    // Message.error(err.message); // 错误提示,记得引入message
    console.log('测试数据', err.message);
    return Promise.resolve(err.response);
  }
);

// 各种请求方式,仿照get的方式写即可
export default {
  // get请求
  get(url, param) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: url,
        params: param, // 表单形式提交
        cancelToken: new CancelToken(c => {
          cancel = c;
        })
      }).then(res => {
        resolve(res);
      });
    });
  },
  // post请求
  post(url, param) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: url,
        data: param, // json方式提交
        cancelToken: new CancelToken(c => {
          cancel = c;
        })
      }).then(res => {
        resolve(res);
      });
    });
  },
  put(url, param) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'put',
        url: url,
        data: param, // json方式提交
        cancelToken: new CancelToken(c => {
          cancel = c;
        })
      }).then(res => {
        resolve(res);
      });
    });
  },
  delete(url, param) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url: url,
        data: param, // json方式提交
        cancelToken: new CancelToken(c => {
          cancel = c;
        })
      }).then(res => {
        resolve(res);
      });
    });
  }
};
